import { Component, OnInit, Inject } from '@angular/core';
import { NbMenuService, NB_WINDOW } from '@nebular/theme';

import { Router } from '@angular/router';
import { AuthService } from 'src/app/facade/auth/auth.service';
import { User } from 'src/app/common/interfaces/user';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
	authHeader = false;
	user: User;

	notLandingHeader = false;

	items = [{ title: 'Logout' }];

	constructor(
		private nbMenuService: NbMenuService,
		private router: Router,
		private authService: AuthService,
		private menuService: NbMenuService,
		@Inject(NB_WINDOW) private window
	) {
		router.events.subscribe(val => {
			this.checkHeader();
		});
	}

	ngOnInit() {
		this.checkHeader();
		this.authService.currentUser.subscribe(
			result => {
				this.user = result;
			},
			error => {
				console.log(error);
			}
		);
		console.log(this.user);

		this.menuItemClick();
	}

	menuItemClick() {
		this.menuService.onItemClick().subscribe(event => {
			if (event.item.title === 'Logout') {
				this.handleLogOut();
			}
		});
	}

	handleLogOut() {
		this.authService.logout();
	}

	checkHeader() {
		if (
			this.router.url === '/login' ||
			this.router.url === '/reset-password' ||
			this.router.url === '/forgot-password'
		) {
			this.notLandingHeader = true;
		} else {
			this.notLandingHeader = false;
		}
	}
}
